import React from 'react'

import Selection from './Selection'
import SecondApplicantForm from './SecondApplicantForm'

class ApplicantsForm extends React.Component {

  onApplicantChange = (key, value) => {
    this.props.onApplicantChange(key, value)
  }

  render() {
    const {
      onSelectionChange,
      onApplicantChange,
      applicant,
      userName,
      userMobile,
      userEmail,
      errors,
    } = this.props

    return(
      <div>
        <Selection
          onChange={ (value) => onSelectionChange(value) }
        />
        {
          (applicant === 'secondary') && (
            <SecondApplicantForm
              userName={ userName }
              userMobile={ userMobile }
              userEmail={ userEmail }
              onApplicantChange={ this.onApplicantChange }
              errors={ errors }
            />
          )
        }
      </div>
    )
  }
}

export default ApplicantsForm
